import Flag from 'react-world-flags';

import { Languages } from 'app-types/desk';
import { Catalan } from 'icons/icons/flags';
import { useIntl } from 'localization';

const useGetSupportedLanguages = (
  iconSize: { width: string | number; height: string | number } = { width: '18px', height: '14px' },
) => {
  const { formatMessage } = useIntl();

  const result = Object.values(Languages)
    .map((language) => {
      return {
        label: formatMessage({ id: `desk-app.${language}` }),
        value: language,
        icon: specialCountryFlags[language] ? (
          specialCountryFlags[language]?.(iconSize)
        ) : (
          <Flag
            className="rounded-sm object-cover"
            code={countryCodes[language]}
            style={iconSize}
          />
        ),
        countryCode: countryCodes[language],
        ISOCode: isoCodes[language.toLowerCase()],
      };
    })
    .sort((a, b) => a?.label?.localeCompare(b?.label));

  return result;
};

export default useGetSupportedLanguages;

const specialCountryFlags: Partial<
  Record<Languages, (iconSize: { width: string | number; height: string | number }) => JSX.Element>
> = {
  [Languages.Ca]: (iconSize) => <Catalan className="rounded-sm object-cover" style={iconSize} />,
};

export const countryCodes: Record<Languages, string> = {
  [Languages.Bg]: 'BG',
  [Languages.Ca]: 'ES-CA',
  [Languages.Cs]: 'CZ',
  [Languages.Da]: 'DK',
  [Languages.De]: 'DE',
  [Languages.El]: 'GR',
  [Languages.En]: 'GB',
  [Languages.Es]: 'ES',
  [Languages.Et]: 'EE',
  [Languages.Fi]: 'FI',
  [Languages.Fr]: 'FR',
  [Languages.Ga]: 'IE',
  [Languages.Hr]: 'HR',
  [Languages.Hu]: 'HU',
  [Languages.It]: 'IT',
  [Languages.Lt]: 'LT',
  [Languages.Lv]: 'LV',
  [Languages.Nl]: 'NL',
  [Languages.No]: 'NO',
  [Languages.Pl]: 'PL',
  [Languages.Pt]: 'PT',
  [Languages.Ro]: 'RO',
  [Languages.Sk]: 'SK',
  [Languages.Sl]: 'SI',
  [Languages.Sv]: 'SE',
  [Languages.Ar]: 'SA',
};

export const isoCodes: Record<string, string> = {
  en: 'en-EN',
  es: 'es-ES',
  et: 'et-EE',
  de: 'de-DE',
  fi: 'fi-FI',
  fr: 'fr-FR',
  it: 'it-IT',
  lt: 'lt-LT',
  lv: 'lv-LV',
  pt: 'pt-PT',
  pl: 'pl-PL',
  ca: 'ca-ES',
  nl: 'nl-NL',
  bg: 'bg-BG',
  hr: 'hr-HR',
  cs: 'cs-CZ',
  da: 'da-DK',
  el: 'el-GR',
  hu: 'hu-HU',
  ga: 'ga-IE',
  ro: 'ro-RO',
  sk: 'sk-SK',
  sl: 'sl-SI',
  sv: 'sv-SE',
  no: 'no-NO',
  ar: 'ar-SA',
};
